export const PageNotFound = () => {
  return (
    <div>
      <h1>Página não encontrada...</h1>
    </div>
  );
};
